import { Action } from 'redux';
import { IWorkflowItem, IWorkflowItemStep } from '../../../common/sharedTypes';

export interface IDriverReportQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
  id: string;
}

// ACTIONS
export interface IDriverReportQueueAction extends Action {
  type: '@@dataentryqueue/GET_DATA_ENTRY_QUEUE_REPORTS';
  payload: {};
}

export enum DriverReportQueueActionTypes {
  SEARCH_REPORTS = '@@transcribeValidationQueue/GET_DATA_ENTRY_QUEUE_REPORTS',
  GET_REPORT_DATA = '@@transcribeValidationQueue/GET_REPORT_DATA',
  OPEN_REPORT = '@@transcribeValidationQueue/OPEN_REPORT',
  ASSIGN_AND_OPEN_REPORT = '@@transcribeValidationQueue/ASSIGN_AND_OPEN_REPORT',
  UNASSIGN = '@@transcribeValidationQueue/UNASSIGN',
  COMPLETE_DATA_ENTRY = '@@transcribeValidationQueue/COMPLETE_DATA_ENTRY',
  SAVE_DATA_TRANSCRIBE_VALIDATION = '@@transcribeValidationQueue/SAVE_DATA_TRANSCRIBE_VALIDATION',
}

export type QNotificationActions = IDriverReportQueueAction;
